var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Card, compose, graphql, Grid, GridColumn, PageLayout, RightDiv, Separator, Spinner, withGraphqlErrorFlags, withLoadingSpinner, withMountTracking, withShowFlag, Link } from "@atlassiansox/microscopekit";
import Button from "@atlaskit/button";
import WargameDetailsQuery from "../graphql/wargame-details.query.graphql";
import serviceQuery from "../graphql/service.query.graphql";
import { withServiceNotFoundHandler } from "@atlassiansox/microscopekit/dist/src/error/with-service-not-found-handler";
import { FaultExecutionView } from "../components/ExecutionView/FaultExecutionView";
import { PremiseExecutionView } from "../components/ExecutionView/PremiseExecutionView";
import WargameDashboardQuery from "../graphql/wargame-dashboard.query.graphql";
import { SteadyStateExecutionView } from "../components/ExecutionView/SteadyStateExecutionView";
import { statusLozenge } from "../utils/Utils";
import EditorOpenIcon from "@atlaskit/icon/glyph/editor/open";
import { AbortWargameButton } from "../components/AbortWargameButton";
import { TimeComponent } from "../components/TimeComponent";
import { DateComponent } from "../components/DateComponent";
var WargameDetailsView = function (props) {
    var _a, _b;
    var wargame = props.wargameDetailsData.warGame
        ? props.wargameDetailsData.warGame
        : {};
    var signalFxUrl = props.wargameDashboardData.warGameDashboard
        ? props.wargameDashboardData.warGameDashboard
        : "";
    var isWargameUnfinished = unfinishedStatuses.includes(wargame.status);
    useEffect(function () {
        if (isWargameUnfinished) {
            props.wargameDetailsData.startPolling(10000);
        }
        else {
            props.wargameDetailsData.stopPolling();
        }
    }, [isWargameUnfinished, props.wargameDetailsData]);
    return props.wargameDetailsData.loading ? (React.createElement(Spinner, null)) : (React.createElement("div", null,
        React.createElement(PageLayout, { title: "" },
            React.createElement("h2", null,
                "Wargame #",
                wargame.id,
                " Details"),
            React.createElement(Separator, null),
            React.createElement(Grid, null,
                React.createElement(GridColumn, { medium: 8 },
                    React.createElement("p", null,
                        "Service: ",
                        wargame.service),
                    wargame.environment && React.createElement("p", null,
                        "Environment: ",
                        wargame.environment),
                    React.createElement("p", null,
                        "User Id: ",
                        wargame.userId),
                    React.createElement("p", null,
                        "status: ",
                        statusLozenge(wargame.status)),
                    React.createElement("p", null,
                        "Wargame Plan:",
                        " ",
                        React.createElement(Link, { to: "./template-details?id=" + wargame.wargameTemplateId },
                            wargame.wargameTemplateId,
                            React.createElement(EditorOpenIcon, { label: "preview" }))),
                    React.createElement(DateComponent, { createdAt: wargame.createdAt }),
                    React.createElement(TimeComponent, { createdAt: wargame.createdAt, updatedAt: wargame.updatedAt, status: wargame.status })),
                React.createElement(GridColumn, { medium: 4 },
                    React.createElement(RightDiv, null,
                        React.createElement("a", { href: signalFxUrl, target: "_blank", rel: "noopener noreferrer" },
                            React.createElement(Button, { appearance: "primary" }, "Signal FX Dashboard")),
                        React.createElement(Separator, null),
                        isWargameUnfinished && React.createElement(AbortWargameButton, { id: wargame.id })))),
            React.createElement(Separator, null), (_a = wargame.premiseExecutions) === null || _a === void 0 ? void 0 :
            _a.map(function (premiseExecution, index) { return (React.createElement(PremiseExecutionView, { key: "premiseExecution-" + index, premiseExecution: premiseExecution, index: index })); }), (_b = wargame.taskGroupExecutions) === null || _b === void 0 ? void 0 :
            _b.map(function (taskGroupExecution, index) { return (React.createElement("div", null,
                React.createElement("h4", null,
                    "Task Group #",
                    index),
                React.createElement(Card, null,
                    React.createElement("h4", null, "Stop Condition Hypothesis"),
                    React.createElement(Separator, null),
                    taskGroupExecution.steadyStateExecutions ? (taskGroupExecution.steadyStateExecutions.length === 0 ? (React.createElement("p", null, "No Stop Condition Executions present")) : (taskGroupExecution.steadyStateExecutions.map(function (steadyStateExecution, index) { return (React.createElement(SteadyStateExecutionView, { key: "steadyStateExecutions" + { index: index }, steadyStateExecution: steadyStateExecution })); }))) : (React.createElement(Card, null, "No Stop Condition Executions present")),
                    React.createElement(Separator, null),
                    React.createElement(Separator, null),
                    React.createElement("h4", null, "Faults"),
                    React.createElement(Separator, null),
                    taskGroupExecution.faultExecutions ? (taskGroupExecution.faultExecutions.map(function (faultExecution, index) { return (React.createElement(FaultExecutionView, { key: "faultExecutions" + { index: index }, faultExecution: faultExecution })); })) : (React.createElement(Card, null, "No Fault Executions present"))))); }))));
};
var unfinishedStatuses = ["in_progress", "pending"];
var withWargameId = function (Component) {
    return function (props) {
        var _a;
        var wargameId = (_a = new URLSearchParams(props.location.search).get("id")) !== null && _a !== void 0 ? _a : "";
        return React.createElement(Component, __assign({ wargameId: wargameId }, props));
    };
};
export var WargameDetailsPage = compose(withRouter, withWargameId, graphql(serviceQuery, {}), graphql(WargameDetailsQuery, {
    name: "wargameDetailsData",
    options: function (props) { return ({
        query: WargameDetailsQuery,
        variables: { id: props.wargameId, skip: !props.wargameId }
    }); }
}), graphql(WargameDashboardQuery, {
    name: "wargameDashboardData",
    options: function (props) { return ({
        query: WargameDetailsQuery,
        variables: { id: props.wargameId, skip: !props.wargameId }
    }); }
}), withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, withServiceNotFoundHandler, withMountTracking("Credo.CredoPage"))(WargameDetailsView);
